import React, { useState, createRef } from "react";
import "./style/images.css"; // Importa il file CSS
import anemoneImg from "../../images/anemone-compressed.jpg";
import { LazyLoadImage } from "react-lazy-load-image-component";

const initialPosition = {
	x: "",
	y: "",
};

function AnemoneImg() {


	// const [imageLoaded, setImageLoading] = useState(false);
	// useEffect(() => {
	// 	const img = new Image();
	// 	img.onLoad = () => {
	// 		setImageLoading(true);
	// 	};
	// 	img.src = anemoneImg;
	// }, [anemoneImg]);

	const [tagPosition, setTagPosition] = useState(initialPosition);

	const imageWrapRef = createRef();
/*
	const handleTagClick = (e) => {
		const { left, top } = imageWrapRef.current.getBoundingClientRect();
		const x = ((e.clientX - left) / anemoneImg.offsetWidth) * 100;
		const y = ((e.clientY - top) / anemoneImg.offsetHeight) * 100;
		setTagPosition((prev) => ({ ...prev, x, y }));
	};*/

	return (
		/*<div onClick={(e) => handleTagClick(e)} ref={imageWrapRef}>
			<div
				style={{
					left: `${tagPosition.x}%`,
					top: `${tagPosition.y}%`,
					zIndex: 2,
					padding: 10,
					position: "absolute",
					background: "black"
				}}
			>
				<a></a>
			</div>*/
			<LazyLoadImage
				src={anemoneImg}
				alt="Anemone"
				className="img-responsive"
				width={anemoneImg.offsetWidth}
				height={anemoneImg.offsetHeight}
				effect="blur"
			/>
		/*</div>*/
	);
}

export default AnemoneImg;
